import { gql } from '@apollo/client';

export default gql`
  fragment FullTalent on Talent {
    number_of_active_matcher_assignments
    currency
    company_pool_connections {
      company {
        id
        name
      }
      status
      initiator
      cancel_initiator
    }

    join_reason
    stream_chat_id
    origin
    stream_chat_token
    default_company_referral_key
    is_authorized_to_work_in_the_us
    desired_job_types

    first_name_abac {
      value
    }
    last_name_abac {
      value
    }
    available_date_updated_at
    account_type
    address
    location
    city
    state
    future_relocation_preferences {
      country
      city
      state
    }
    employee_name_who_referred
    is_agree_to_terms_and_conditions
    is_bilingual
    languages
    marketing_source
    work_type
    region
    recent_position_title
    about
    id
    created_at
    rate
    rate_min
    rate_max
    salary
    is_invitation_accepted
    is_verification_required
    is_matcher
    is_static
    email_abac {
      value
    }
    available_date
    hours_per_week
    available_now
    is_ot_pool
    reminded_at
    account_settings {
      locale
      pref_date_format
      receive_company_and_product_updates
      instant_matches_notifications_min_score
      receive_sms_and_phone_calls
      receive_marketing_emails
    }
    companies {
      id
      name
    }
    category {
      id
      name
      slug
      created_at
      updated_at
    }
    subcategories {
      id
      name
    }
    source {
      id
      name
      logo
      created_at
      updated_at
    }
    avatar {
      avatar
      hash
    }
    documents {
      title
      size
      content_type
      hash
      created_at
      updated_at
      is_primary_cv
      type
      url_abac {
        value
      }
    }
    facebook_url
    linkedin_url
    upwork_url
    github_url
    dribbble_url
    behance_url
    adobe_portfolio_url
    bitbucket_url
    canva_url
    figma_url
    gitlab_url
    instagram_url
    kaggle_url
    medium_url
    notion_url
    other_url
    personal_portfolio_url
    zip
    slideshare_url
    talent_data {
      phone
      vat_number
    }
    invited_by {
      company_name
      first_name_abac {
        value
      }
      last_name_abac {
        value
      }
      invitation_type
      id
    }
    talent_work_history {
      id
      position_title
      company_name
      worked_from
      worked_to
      created_at
      updated_at
    }
    skills(first: 50) {
      data {
        id
        skill_type: skill_type
        name
      }
    }
  }
`;
